import { useEffect } from "react";
import useLeaflet from "../hooks/useLeaflet";
const L: any = require("leaflet");
L.esri = require("esri-leaflet");

/*
 * This component displays the creeks on the map
 */
const Creeks = (props) => {
  const context = useLeaflet();

  useEffect(() => {
    if (!context) return;

    const layer = L.esri.featureLayer({
      //pladser fra gis
      url:
        " https://services6.arcgis.com/QHir1urgnGYroCLG/arcgis/rest/services/Vandl%C3%B8b301123/FeatureServer/0",
      style: (feature) => {
        return {
          color: "#0077be",
          opacity: 0.5,
          weight: 4,
        };
      },
    });

    layer
      .on("mouseover", (e) => {
        console.log(e.layer.feature);
        layer.setFeatureStyle(e.layer.feature.id, {
          color: "#5577be",
          opacity: 0.7,
          weight: 10,
        });
      })
      .on("mouseout", (e) => {
        layer.resetStyle(e.layer.feature.id);
        console.log(e.layer.feature);
      })
      .bindTooltip((layer) => {
        return layer.feature.properties.VANDLØB;
      });

    layer.on("click", (e) => {
      console.log(e.layer.feature);
      props.onClick && props.onClick(e.layer.feature);
    });

    layer.addTo(context.map);

    return () => {
      context.map.removeLayer(layer);
    };
  }, [context.map, props.language]);

  return null;
};

export default Creeks;
